import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SslBypassInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Replace https with http for development to bypass SSL certificate issues
    if (request.url.startsWith('https://localhost')) {
      const modifiedRequest = request.clone({
        url: request.url.replace('https://', 'http://')
      });
      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}
